export enum CandidateAssignment {
    Your = 1,
    Others = 2,
    Unassigned = 3
}
